import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';
import type { Blocker, BlockerCategory } from '../../types/conversationState';
import { resolveBlockerTemplate } from '../../constants/blockerTemplates';

type Props = {
  blocker: Blocker;
  onClick: (template: string) => void;
};

const CATEGORY_COLORS: Record<BlockerCategory, string> = {
  outward: '#0080cb',
  homeward: '#4295b6',
  hotel: '#959aa9'
};

const formatAssumedDateForDisplay = (yyyymmdd: string): string => {
  const match = yyyymmdd.match(/^\d{4}-(\d{1,2})-(\d{1,2})$/);
  if (!match) return yyyymmdd;
  return `${Number(match[1])}/${Number(match[2])}`;
};

const buildChipTemplate = (blocker: Blocker, baseTemplate: string): string => {
  if (blocker.type === 'date_confirmation' && blocker.assumedDate) {
    const display = formatAssumedDateForDisplay(blocker.assumedDate);
    return `${baseTemplate}${display}で大丈夫です`;
  }
  return baseTemplate;
};

const BlockerChip = ({ blocker, onClick }: Props) => {
  const { theme } = useAITTheme();
  const template = resolveBlockerTemplate(blocker);
  const styles = useMemo(() => getStyles(theme), [theme]);
  const color = CATEGORY_COLORS[blocker.category];

  return (
    <button
      type="button"
      style={{ ...styles.chip, borderColor: color, color }}
      onClick={() => onClick(buildChipTemplate(blocker, template.template))}
    >
      {template.label}
    </button>
  );
};

const getStyles = (_theme: AITTheme) => ({
  chip: {
    padding: '6px 12px',
    borderRadius: '16px',
    border: '1px solid',
    backgroundColor: '#ffffff',
    fontSize: '13px',
    cursor: 'pointer'
  }
});

export default BlockerChip;
